import React from 'react';
import { motion } from 'framer-motion';
import { steps } from '../data/faqs';
export function Steps() {
  return <section aria-label="Cómo funciona" className="bg-warm" data-id="element-229" data-mp="18d1ranxk8i7w">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "12px",
      paddingBottom: "22px"
    }} data-id="element-230" data-mp="umyawdld3iqd">
        <div className="text-center" data-id="element-231" data-mp="yns1xfu3pdnh">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-232" data-mp="ymqjureo3qw9">
            Cómo empezarás a organizar tu preparación desde hoy
          </h2>
          <p className="mt-3 text-base text-navy/60" data-id="element-233" data-mp="poen07n7jwvd">En 3 sencillos pasos</p>
        </div>

        <ol className="relative mt-12 grid gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-234" data-mp="bovpe8s0w3xb">
          <span aria-hidden="true" className="absolute bottom-6 left-[21px] top-6 w-px bg-electric/30 lg:bottom-auto lg:left-[22px] lg:right-[22px] lg:top-[21px] lg:h-px lg:w-auto" data-id="element-235" data-mp="fow5ryyomp70" />
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-5 lg:flex-col lg:gap-5" data-id="element-236" data-mp="2a3qcxp8ua9rc" data-mpi={i}>
              <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-electric font-display text-xl font-extrabold text-white" data-id="element-237" data-mp="200dldfnw10ix">
                {s.n}
              </span>
              <div data-id="element-238" data-mp="17ekhf2quvfuk">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-navy" data-id="element-239" data-mp="12deop4x73sl1">{s.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy/70" data-id="element-240" data-mp="1hb713o7g40v0">{s.body}</p>
                {s.tags.length > 0 && <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-241" data-mp="1cbb4wb4zpdq0">
                    {s.tags.map(t => <li key={t} className="rounded-md border border-navy/10 bg-white px-2.5 py-1 text-xs font-medium text-navy/75" data-id="element-242" data-mp="2spkneomjw88x">
                        {t}
                      </li>)}
                  </ul>}
                {s.after && <p className="mt-3 text-[15px] leading-relaxed text-navy/70" data-id="element-243" data-mp="2uswcl36gpmt2">{s.after}</p>}
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}